const confirmationModalReducerReducer = (state = [], action) => {
    switch (action.type) {
    case 'SHOW_CONFIRMATION_MODAL':
        return action.payload;
    default:
        return state;
    }
};
export default confirmationModalReducerReducer;
